import { render, staticRenderFns } from "./HandleSourceDialog.vue?vue&type=template&id=46536048&scoped=true"
import script from "./HandleSourceDialog.vue?vue&type=script&lang=js"
export * from "./HandleSourceDialog.vue?vue&type=script&lang=js"
import style0 from "./HandleSourceDialog.vue?vue&type=style&index=0&id=46536048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46536048",
  null
  
)

export default component.exports